export const CSV_FILE_TYPE = 'text/csv';
export const MICROSOFT_CSV_FILE_TYPE = 'application/vnd.ms-excel';
export const XLSX_FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const UPLOAD_OK_STATUS = 'ok';
export const UPLOAD_ERROR_STATUS = 'error';
export const UPLOAD_LOADING_STATUS = 'loading';
export const PNG_CONTENT_TYPE = 'image/png';
export const JPEG_CONTENT_TYPE = 'image/jpeg';
export const PDF_CONTENT_TYPE = 'application/pdf';
export const XML_FILE_TYPE = 'text/xml';
